export interface TabBox {
  left: number
  width: number
}

export interface TabViewport {
  scrollLeft: number
  clientWidth: number
  scrollWidth: number
  inset: number
}

export function revealScrollLeft(tabs: TabBox[], activeIndex: number, view: TabViewport): number {
  const max = Math.max(0, view.scrollWidth - view.clientWidth)
  const active = tabs[activeIndex]
  if (!active || max === 0) {
    return view.scrollLeft
  }

  const clamp = (value: number) => Math.min(max, Math.max(0, value))
  const shows = (scrollLeft: number) => {
    const startInset = scrollLeft > 0 ? view.inset : 0
    const endInset = scrollLeft < max ? view.inset : 0
    return (
      active.left >= scrollLeft + startInset &&
      active.left + active.width <= scrollLeft + view.clientWidth - endInset
    )
  }

  if (shows(view.scrollLeft)) {
    return view.scrollLeft
  }

  const snap = (value: number) => {
    const point = clamp(value)
    if (point <= view.inset) {
      return 0
    }
    if (max - point <= view.inset) {
      return max
    }
    return point
  }

  const snapPoints = [
    ...tabs.map((tab, index) => (index === 0 ? 0 : snap(tab.left - view.inset))),
    max,
  ]
  return snapPoints.find(shows) ?? snap(active.left - view.inset)
}
